import template from './rw-move-widget.html';

export default class RwMoveWidgetComponent {
  constructor() {
    this.template = template;

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-move-widget/rw-move-widget-component.js